import { autoRegisterFeature } from '@store/features/factory';

import { ehrExtensionPromoFeature } from './store/feature';

autoRegisterFeature(ehrExtensionPromoFeature);

export { HomeEhrBanner } from './components/HomeEhrBanner';
export type { EhrExtensionPromoState } from './store';
export {
  dismissHomeBanner,
  dismissPromo,
  selectShouldShowEhrHomeBanner,
  selectShouldShowEhrPromo,
  snoozeHomeBanner,
  snoozePromo,
} from './store';
